"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryInitRequest = void 0;
var LotteryInitRequest = /** @class */ (function () {
    function LotteryInitRequest() {
    }
    return LotteryInitRequest;
}());
exports.LotteryInitRequest = LotteryInitRequest;
;
//# sourceMappingURL=lotteryInit.request.js.map